module.exports = __webpack_public_path__ + "static/media/coming.f5f95064.webp";